import React from "react";
import { Award, MapPin, ShieldCheck } from "lucide-react";

export default function Odoc({ t }) {
  return (
    <section id="odoc" className="relative py-24 md:py-32 overflow-hidden" data-testid="odoc-section">
      {/* Background glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[60rem] h-[60rem] rounded-full bg-amber-600/[0.06] blur-3xl" />
      </div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-amber-600 text-stone-950 mb-8 ring-8 ring-amber-600/10">
          <Award size={36} strokeWidth={1.5} />
        </div>

        <div className="text-amber-500 text-xs uppercase tracking-[0.3em] mb-4">{t.eyebrow}</div>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-stone-50 leading-tight max-w-4xl mx-auto">
          {t.title}
        </h2>

        <div className="mt-10 max-w-3xl mx-auto space-y-5 text-stone-300 text-base md:text-lg leading-relaxed">
          <p>{t.p1}</p>
          <p className="text-stone-200">{t.p2}</p>
        </div>

        <div className="mt-14 grid sm:grid-cols-3 gap-4">
          <Pill icon={<ShieldCheck />} label={t.badge_state} />
          <Pill icon={<MapPin />} label={t.badge_tourism} />
          <Pill icon={<Award />} label={t.badge_credibility} />
        </div>
      </div>
    </section>
  );
}

function Pill({ icon, label }) {
  return (
    <div className="heritage-card flex items-center justify-center gap-3 px-5 py-5">
      <span className="text-amber-500">{icon}</span>
      <span className="text-stone-100 text-sm uppercase tracking-wider font-medium">{label}</span>
    </div>
  );
}
